// 组件预览容器的默认宽高
export const DEFAULT_CODE_PREVIEW_COMPONENT_WIDTH = 1000;
export const DEFAULT_CODE_PREVIEW_COMPONENT_HEIGHT = 358;

// 自定义生成组件的入口组件的默认宽高
export const DEFAULT_CUSTOM_INIT_WIDTH = 1000;
export const DEFAULT_CUSTOM_INIT_HEIGHT = 430;
// 独立卡片模式下
export const DEFAULT_CUSTOM_INIT_HEIGHT_IN_CARD = 489;

/** 上报 id 映射表 */
export const LogIdMap = {
    /** 自定义组件模块添加 */
    CreateCustomInit: '80001.2.352',
    /** 自定义组件上点击自定义 */
    SelectCustomFromCustomInit: '80001.2.353',
    /** 模版插入 */
    CreateComponentByTemplate: '80001.2.354',
    /** 创作助理对话次数 */
    ChatCount: '80001.2.355',
    /** 代码编辑 */
    CodeEditCount: '80001.2.356',
    /** 组件展示次数 */
    ShowComponent: '80001.2.357',
    /** 组件交互次数 */
    InteractComponent: '80001.2.358',
    /** 对话生成组件完成 */
    GenerateArtifactComplete: '80001.2.359',
    /** 使用说明&群号点击 */
    ClickGuidance: '80001.2.377',
    /** 复制按钮 */
    CopyButton: '80001.2.379',
    /** 申请自定义 */
    ApplyCustomInit: '80001.2.381',
    /** 独立成卡 / 取消独立成卡 */
    SplitOrMerge: '80001.2.380',
    /** 错误重试按钮点击 */
    retryBtnClick: '80001.2.390',
    /** 当前已出现编译错误，点击一键修复按钮尝试修复后，依然出现编译错误 */
    errorAgainAfterRepair: '80001.2.391',
    /** 粘贴组件 */
    pasteComponent: '80001.1.370',
    /** 点击「局部调整」入口 */
    StartViewEditing: '80001.2.382',
    /** 发送局部修改指令区域选择 */
    ChatWithViewEditing: '80001.2.384',
    /** 直接修改文本 */
    ModifyTextWithViewEditing: '80001.2.385',
    /** 局部编辑发送对话后报错 */
    ErrorAfterChatWithViewEditing: '80001.2.383',
    /** 版本回退 */
    SelectPreviousArtifactAfterChatWithViewEditing: '80001.2.386',
    /** 选中历史版本 */
    SelectPreviousArtifact: '80001.2.387',
    /** 基于历史版本进行对话 */
    ChatWithPreviousArtifact: '80001.2.388',
    /** 删除选中历史版本 */
    RemovePreviousArtifact: '80001.2.389',
    /** 对话完成 */
    /** 区别于 80001.2.359，该埋点是每次对话完成时上报一次，而 80001.2.359 是对话有生成 artifact 才会上报 */
    GenerateComplete: '80001.2.393',
    /** 多视图切换 - 入口点击 */
    ViewChangeClickEntry: '80001.1.373',
    /** 多视图切换 - 切换文档状态 */
    ViewChangeOfDocStatus: '80001.1.371',
    /** 多视图切换 - 切换终端 */
    ViewChangeOfEndpoint: '80001.1.372',
    /** 调用sendNotification */
    SendNotification: '80001.2.404',
};

/** 后端随心搭埋点映射表 */
export const LogIdMapForBackend = {
    /** 自定义组件模块添加 */
    CreateCustomInit: '80001.2.394',
    /** 自定义组件上点击自定义 */
    SelectCustomFromCustomInit: '80001.2.395',
    /** 创作助理对话次数 */
    ChatCount: '80001.2.396',
    /** 代码编辑 */
    CodeEditCount: '80001.2.397',
    /** 复制按钮 */
    CopyButton: '80001.2.398',
    /** 独立成卡 / 取消独立成卡 */
    SplitOrMerge: '80001.2.399',
    /** 粘贴组件 */
    pasteComponent: '80001.2.400',
    /** 选中历史版本 */
    SelectPreviousArtifact: '80001.2.401',
    /** 基于历史版本进行对话 */
    ChatWithPreviousArtifact: '80001.2.402',
    /** 对话完成 */
    /** 区别于 80001.2.359，该埋点是每次对话完成时上报一次，而 80001.2.359 是对话有生成 artifact 才会上报 */
    GenerateComplete: '80001.2.403',
};

// 随心搭如流群号
export const RuliuGroupId = '11717613';

/** 随心搭类型 */
export enum FlexBuilderType {
    /** 前端随心搭 */
    frontend = 'frontend',
    /** 后端随心搭 */
    backend = 'backend',
}

export const NodeTypeOfFrontendFlexBuilder = 'flex-builder';
export const NodeTypeOfBackendFlexBuilder = 'flex-builder-backend';

/** 随心搭类型到节点类型的映射表 */
export const FlexBuilderTypeToNodeTypeMap = {
    [FlexBuilderType.frontend]: NodeTypeOfFrontendFlexBuilder,
    [FlexBuilderType.backend]: NodeTypeOfBackendFlexBuilder,
};

/** 用于给前端随心搭使用的后端随心搭的 prompt 模板 */
export const BackendFlexBuilderPromptTemplateForFlexBuilderUse = '接口请求方法使用Ku.request.post，接口逻辑按照以下接口文档实现：';
